import { ChiptaElement, html } from 'chipta-libs/main.js';
import { basicIconStyle } from 'styles/basic-icon.js';


class IconHamburger extends basicIconStyle(ChiptaElement) {

  render() {
    return html`
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
      >
        <line x1='3' y1='12' x2='21' y2='12' />
        <line x1='3' y1='6' x2='21' y2='6' />
        <line x1='3' y1='18' x2='21' y2='18' />
      </svg>
    `;
  }

}

customElements.define('icon-hamburger', IconHamburger);
